import { createAsyncThunk } from '@reduxjs/toolkit';
import { _appointmentUrls } from '@custom/Utils/constants/apiUrls';

const appointmentDetailsbyPatientId = createAsyncThunk('appointmentDetailbyPatientId', async (patientId) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      let url = `${_appointmentUrls.getAppointmentWithPatientId}/${patientId}`;
      let response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
        
      if (!response.ok) {
        throw new Error('Failed to fetch appointment details');
      }

      return await response.json();
    } catch (error) {
      return Promise.reject(error);
    }
  });



export default appointmentDetailsbyPatientId;
